<template>
  <div class="content-editor-block carousel">

    <div v-if="!hasItem">
      <div class="hint-inserting-first"
        @click="addBlock(Entities[EntityInfo.imageIdx])">
        點擊插入第一則圖片
      </div>
      <div class="hint-inserting-first"
        @click="addBlock(Entities[EntityInfo.videoIdx])">
        點擊插入第一則影片
      </div>
    </div>
    <div v-else>
      <slot name="items" :items="mValue.items" :page="currentPage" :onRemoved="onRemoved"></slot>

      <el-pagination
        v-if="hasItem"
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="1"
        :total="mValue.items.length"
        @current-change="onChangePage">
      </el-pagination>

      <button @click="addBlock(Entities[EntityInfo.imageIdx])">新增圖片</button>
      <button @click="addBlock(Entities[EntityInfo.videoIdx])">新增影片</button>
      <button v-if="currentPage !== 1 && mValue.items.length > 1" @click="sort2Prev">&#8592;順序往前</button>
      <button v-if="currentPage !== mValue.items.length && mValue.items.length" @click="sort2Next">順序往後&#8594;</button>
    </div>

    <!-- 因為無法 double recursive 引入 ContentEditorBlock， 這邊使用slot方式 -->

    <!-- <ContentEditorBlock
      v-if="hasItem"
      v-for="(item,idx) in mValue.items"
      :key="`carousel-${'todo: key'}-item-${idx}`"
      v-model="mValue.items[idx]"
      :is-sub-block="true"
      @input="onInput"
      @remove="onRemove(idx)"/> -->

  </div>
</template>

<script>
import Entity from '@/utils/content-editor/entities.js'
export default {
  name: 'carousel-editor',
  components: {},
  props: {
    value: {
      default: () => {
        return {
          settings: {},
          items: []
        }
      }
    }
  },
  data: () => {
    return {
      mValue: {},
      currentPage: 1
    }
  },
  computed: {
    hasItem () {
      return this.mValue.items && this.mValue.items.length
    },
    Entities () {
      return Entity.all
    },
    EntityInfo () {
      return Entity
    }
  },
  methods: {
    sort2Prev () {
      let currentItem = this.mValue.items[this.currentPage - 1]
      this.mValue.items.splice(this.currentPage - 1, 1)
      this.mValue.items.splice(this.currentPage - 1 - 1, 0, currentItem)
      this.currentPage -= 1
    },
    sort2Next () {
      let currentItem = this.mValue.items[this.currentPage - 1]
      this.mValue.items.splice(this.currentPage - 1, 1)
      this.mValue.items.splice(this.currentPage - 1 + 1, 0, currentItem)
      this.currentPage += 1
    },
    onChangePage (page) {
      this.currentPage = page
    },
    addBlock (entityInfo) {
      this.mValue.items.push(new entityInfo.Class())
      this.onInput()
      if (this.mValue.items.length > 1) {
        this.$nextTick(() => {
          this.currentPage = this.mValue.items.length
        })
      }
    },
    onInput () {
      this.$emit('input', this.mValue)
    },
    onRemoved (page) {
      let shouldChangeToPrevPage = this.currentPage >= page && page > 1
      this.mValue.items.splice(page - 1, 1)
      this.onInput()
      if (shouldChangeToPrevPage) {
        this.currentPage -= 1
      }
    }
  },
  created () {
    this.mValue = this.value
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
